import React from "react";
import { string, func, bool } from "prop-types";

import "./button.m.css";

const Button = ({ content, onClick, buttonType, isArrow, isOpen, className, ...props }) => {
  const arrowView = () => (isOpen ? <i styleName="up" className="up" /> : <i styleName="down" className="down" />);

  return (
    <button styleName={buttonType} className={className} onClick={onClick} {...props}>
      {content}
      {isArrow ? arrowView() : null}
    </button>
  );
};

Button.defaultProps = {
  buttonType: "type1",
  isOpen: false,
  isArrow: false,
  className: "button"
};

Button.propTypes = {
  content: string.isRequired,
  onClick: func,
  buttonType: string,
  isOpen: bool,
  isArrow: bool,
  className: string
};

export default Button;
